import { Home, GeneralSettings } from "../SibaIcons/index";

export interface IMenuItem {
    id: number;
    icon: JSX.Element | string;
    link: string;
    toolTip: string;
    roles: Array<string>;
    iconPng: any;
    name: string;
}
/**
 *
 * */
export interface IPageMaps {
    path: string;
    name: string;
    items: IPageMaps[] | undefined;
    level?: number; //this property is only used internally
    icon?: any;
}

/**
 * RightBar //component view
 * @returns Array<IMenuItem>
 */
export const mainMenuListItems: IMenuItem[] = [
    {
        id: 0,
        toolTip: "Home",
        name: "Home",
        icon: "",
        iconPng: Home,
        link: "home",
        roles: ["admin"]
    },

    {
        id: 4,
        toolTip: "General Settings",
        link: "Settings",
        roles: ["admin"],
        name: "General Settings",
        icon: "",
        iconPng: GeneralSettings
    }
];

/**
 * if the object still has a nested items property,
 * repeat process.
 * **/
function checkIfNested(c: IPageMaps) {
    if (c.items) {
        multiLevel(c.level ?? 0, c.items);
    }
}
/**
 * append level index for identation when redering on sidebar
 * this will make child nested items appear indente compered to their parent items.
 * **/
const multiLevel = (upperlevel: number, children: IPageMaps[]) => {
    children.forEach((c) => {
        c.level = upperlevel + 20;
        checkIfNested(c);
    });
};

/****
 * method to add addition property level to object that detemines level of spacing or indentation on side memu.
 * **/

export const indentMenuItems = (items: IPageMaps[]) => {
    items = items.filter((x) => x);
    items.forEach((x) => {
        x.level = 5;
        if (x.items) {
            multiLevel(x.level, x.items);
        }
    });

    return items;
};
